import { render, staticRenderFns } from "./left2.vue?vue&type=template&id=7729689f&scoped=true&"
import script from "./left2.vue?vue&type=script&lang=js&"
export * from "./left2.vue?vue&type=script&lang=js&"
import style0 from "./left2.vue?vue&type=style&index=0&id=7729689f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7729689f",
  null
  
)

export default component.exports